import React from 'react';

import './StepRadioOptions.css';

const StepRadioOptions = ({
    stepText,
    name,
    options,
    interactionData,
    onOptionChange
}) => {

    const renderOptionsHtml = (options) =>  {
        return options.map(option => renderOptionHtml(option));
    }

    const renderOptionHtml = (option) => {
       
        return (
            <p
                id={ `slc-step-option-${ option.value }` }
                className="slc-step-option"
                key={ option.value }>
                <label>
                    <input
                        type="radio"
                        name={ name }
                        id={ option.value }
                        value={ option.value }
                        checked={ interactionData[option.value] }
                        onChange={ onOptionChange } />
                    <span>{ option.label }</span>
                </label>
            </p>
        );

    }

    return (
        <div className="slc-step-options-radio">
            <div className="slc-step-options-radio__text slc-step-text--title">
                { stepText }
            </div>
            <div className="slc-step-options-radio__options">
                { renderOptionsHtml(options) }
            </div>
        </div>
    );

};

export default StepRadioOptions;